import React, { FC, useContext } from "react";
import { Link } from "react-router-dom";
import { ActiveMattersStatusFilterList, LiveMatterOrderBy, HTMLLink } from "@design-system";
import { MatterStatus } from "../graphql/__generated_types__/globalTypes";
import { useQuery } from "@apollo/client";
import { FIND_ACCRUED_FEES_FOR_ORG_UNIT, FIND_ACCRUED_FEES_FOR_USER } from "../graphql/query";

type MyFilteredMattersContainerProps =
  | {
      status: MatterStatus;
      filterBy: "user";
      orderBy: LiveMatterOrderBy;
    }
  | {
      status: MatterStatus;
      filterBy: "organisationalUnit";
      organisationalUnitId: number;
      orderBy: LiveMatterOrderBy;
    };

export const MyFilteredMattersContainer: FC<MyFilteredMattersContainerProps> = (props) => {
  const { filterBy, orderBy } = props;

  const orgUnitId =
    props.filterBy === "organisationalUnit" ? props.organisationalUnitId : undefined;
  const {
    data: dataByUser,
    loading: loadingByUser,
    fetchMore: fetchMoreByUser,
  } = useQuery(FIND_ACCRUED_FEES_FOR_USER, {
    variables: {
      filter: {
        // skip: 0,
        // take: 10,
        matterStatus: MatterStatus.Live,
      },
    },
    skip: filterBy === "organisationalUnit",
  });

  const {
    data: dataByOrgUnit,
    loading: loadingByOrgUnit,
    fetchMore: fetchMoreByOrgUnit,
  } = useQuery(FIND_ACCRUED_FEES_FOR_ORG_UNIT, {
    variables: {
      filter: {
        organisationUnitId: orgUnitId!,
        // skip: 0,
        // take: 10,
        matterStatus: MatterStatus.Live,
      },
    },
    skip: filterBy === "user",
  });

  // const onLoadMore = (nextTake: number) => {
  //   if (filterBy === "user") {
  //     fetchMoreByUser({
  //       variables: {
  //         filter: {
  //           skip: dataByUser?.findAccruedFeesForUser.items.length,
  //           take: nextTake,
  //           matterStatus: MatterStatus.Live,
  //         },
  //       },
  //     });
  //   } else {
  //     fetchMoreByOrgUnit({
  //       variables: {
  //         filter: {
  //           organisationUnitId: orgUnitId!,
  //           skip: dataByOrgUnit?.findAccruedFees.items.length,
  //           take: nextTake,
  //           matterStatus: MatterStatus.Live,
  //         },
  //       },
  //     });
  //   }
  // };

  const loading = filterBy === "user" ? loadingByUser : loadingByOrgUnit;
  const data =
    filterBy === "user" ? dataByUser?.findAccruedFeesForUser : dataByOrgUnit?.findAccruedFees;

  const total =
    filterBy === "user"
      ? dataByUser?.findAccruedFeesForUser.total
      : dataByOrgUnit?.findAccruedFees.total;

  return (
    <ActiveMattersStatusFilterList
      onLoadMore={() => {}}
      loading={loading}
      filterBy={filterBy}
      accruedFees={data?.items ?? []}
      total={total ?? 0}
      link={Link as HTMLLink}
      orderBy={orderBy}
    />
  );
};
